import React from 'react';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import { actions as mainActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-n';
import { wrapper } from '@/store';
import { END } from 'redux-saga';
import DATA from '@/utils/data.json';
import PageLayout from '@/layouts';
import { actions as constantsActions } from '@/reducers/constants';

const Public = ({ pageInfo }) => {
  return (
    <>
      <PageLayout pageInfo={pageInfo} />
      <style jsx>{`
        :global(.grecaptcha-badge) {
          display: none;
        }
      `}</style>
    </>
  );
};

export default Public;

export async function getStaticPaths() {
  const paths = Object.keys(DATA);
  return {
    paths: paths.slice(1),
    fallback: true,
  };
}

export const getStaticProps = wrapper.getStaticProps(
  async ({ store, params }) => {
    const { pathname } = params;
    store.dispatch(
      mainActions.getCurrentSeo({
        SEG_NAV: 'empresas',
        location: `fondoseuropeos.telefonica.es/${pathname}`,
        customValues: '{}',
      })
    );
    store.dispatch(
      constantsActions.getBusinessConstants({ path: pathname, build: true })
    );
    store.dispatch(END);

    await store.sagaTask.toPromise();
    return {
      props: {
        pathname,
        pageInfo: DATA[`/${pathname}`],
      },
    };
  }
);
